/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Challenge_Keeping_UpInputs */

const en_onboarding_challenge_keeping_up = /** @type {(inputs: Onboarding_Challenge_Keeping_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keeping up with reading`)
};

const es_onboarding_challenge_keeping_up = /** @type {(inputs: Onboarding_Challenge_Keeping_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantenerme al día con la lectura`)
};

/**
* | output |
* | --- |
* | "Keeping up with reading" |
*
* @param {Onboarding_Challenge_Keeping_UpInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_challenge_keeping_up = /** @type {((inputs?: Onboarding_Challenge_Keeping_UpInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Challenge_Keeping_UpInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_challenge_keeping_up(inputs)
	return en_onboarding_challenge_keeping_up(inputs)
});